<template>
  <div class="relative grid w-screen h-screen overflow-hidden">
    <transition name="slide-up">
      <app-header v-show="$route.name !== 'Home'" class="flex-shrink-0 print:hidden" />
    </transition>

    <transition name="slide-down">
      <app-navigation-menu v-show="$route.name !== 'Home'" class="print:hidden" />
    </transition>

    <div class="relative grid mt-20 mb-12 xl:mb-16 app-view">
      <router-view v-slot="{ Component }" class="relative w-screen">
        <transition :name="transitionName">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>

      <!-- <app-screensaver /> -->
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppNavigationMenu from '@/components/AppNavigationMenu.vue'
// import AppScreensaver from '@/components/AppScreensaver.vue'

export default {
  components: {
    AppHeader,
    AppNavigationMenu,
    // AppScreensaver,
  },
  data () {
    return {
      transitionName: 'page-slide-up',
    }
  },
  watch: {
    '$route' (to, from) {
      this.transitionName = to.meta.pageOrder < from.meta.pageOrder ? 'page-slide-down' : 'page-slide-up'
    },
  },
}
</script>

<style src="swiper/swiper-bundle.css"></style>
<style src="@/assets/css/app.css"></style>
<style lang="postcss">
:root {
  --swiper-theme-color: theme("colors.white");
}

body {
  -webkit-print-color-adjust: exact;
}

.swiper-pagination.swiper-pagination-bullets {
  @apply flex items-center rounded-full h-8 p-1 bg-black bg-opacity-25 w-auto mx-auto;

  left: 50%;
  bottom: 1.5rem;
  transform: translateX(-50%);
  backdrop-filter: blur(16px);
}

.swiper-pagination-bullet {
  @apply w-3 h-3 transition-all duration-300 ring-2 ring-white ring-opacity-30 opacity-50;
}

.swiper-pagination-bullet-active {
  @apply w-4 h-4 rounded-full ring ring-white ring-opacity-50 opacity-100;
}

.status-indicator {
  opacity: 0.75;
}

.status-available {
  fill: theme("colors.green.500");
}

.status-reserved {
  fill: theme("colors.blue.500");
}

.status-sold {
  fill: theme("colors.red.500");
}

.status-onhold {
  fill: theme("colors.gray.500");
}

.status-label {
  @apply font-sans font-bold text-2xl;
}

.Vue-Toastification__toast--success {
  @apply bg-green-500
}

.Vue-Toastification__toast {
  @apply rounded-sm font-sans;
}

.medium-zoom-image--opened:last-of-type {
  @apply z-50;
}
</style>
